import { ApplicationTypes, Model } from 'jms-domain'

import { isInitialNavigationUpdate } from '@salsita-ai/platform-project-sdk/domain'

import { configuratorInterface } from '../systems/configurator-interface'

export const initialNavigationTransformer = configuratorInterface.createTransformer(ctx => (updates, state) => {
  const initialNavigationUpdate = updates.find(isInitialNavigationUpdate)

  if (!initialNavigationUpdate) {
    return updates
  }

  const alreadyWallItems = state.entities.some(Model.WallItem.is)
  if (alreadyWallItems) {
    return [
      ...updates,
      ctx.navigationSystem.getNavigationUpdate(ApplicationTypes.NavigationState.RoomContent),
      ctx.navigationSystem.getSelectUpdate(state.rootEntityId),
    ]
  }

  return updates
})
